// Import jQuery
import jquery from "jquery";

// Expose jQuery to the global window object
window.jQuery = jquery;
window.$ = jquery;